import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function PrivateRoutes({ children }) {
  const { usuario } = useAuth();

  return usuario ? children : <Navigate to="/" />;
}

export default PrivateRoutes;
